import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import { StateController } from '../../helpers/state/state-management/state-controller';
import accountInfo from '../../helpers/state/account-info';
import { undefinedIfEmpty } from '../../helpers/utils';

@customElement('account-avatar')
export class AccountAvatar extends LitElement {
    @property({ type: String })
    size?: string;

    @property({ type: String })
    indent?: string = '0';

    @property({ type: String })
    backgroundColor?: string = 'var(--theme-white-color)';

    @property({ type: String })
    textColor?: string = 'var(--theme-input-color)';

    @property({ type: Boolean })
    isTeam? = false;

    @property({ type: String })
    imageUrl?: string;

    private readonly bindAccountState = new StateController(this, accountInfo);

    connectedCallback() {
        super.connectedCallback();
        if (this.size === 'xl') {
            this.style.setProperty('--avatar-size', '10rem');
            this.style.setProperty('--avatar-font-size', '2rem');
        } else if (this.size === 'lg') {
            this.style.setProperty('--avatar-size', '4.5rem');
            this.style.setProperty('--avatar-font-size', '2rem');
        } else if (this.size === 'sm') {
            this.style.setProperty('--avatar-size', '1.5rem');
            this.style.setProperty('--avatar-font-size', '0.75rem');
        } else if (this.size === 'xs') {
            this.style.setProperty('--avatar-size', '1rem');
            this.style.setProperty('--avatar-font-size', '0.5rem');
        }
        else {
            this.style.setProperty('--avatar-size', '3rem');
            this.style.setProperty('--avatar-font-size', '1.5rem');
        }
    }

    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has('accountInfo')) {
            this.requestUpdate();
        }
    }

    protected render() {
        return html`
            <div class="avatar" style="background-color: ${this.backgroundColor}; ${this.isTeam === true ? 'border-radius: 4px;' : ''}">
                ${undefinedIfEmpty(this.imageUrl)
                    ? html`<img src="${this.imageUrl ?? ''}" style="width: 100%; height: 100%; object-fit: cover;">`
                    : html`
                        <div class="avatarLetters" style="color: ${this.textColor};">
                            <slot></slot>
                        </div>
                    `
                }
            </div>
        `;
    }

    static get styles() {
        return css`
            .avatar {
                display: inline-block;
                vertical-align: middle;
                position: relative;
                cursor: pointer;
                background-color: var(--theme-white-color);
                border-radius: 50%;
                overflow: hidden;
                height: var(--avatar-size);
                width: var(--avatar-size);
                box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
                border: 1px solid var(--theme-border-color);            }

            .avatarLetters {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                font-weight: bold;
                font-size: var(--avatar-font-size);
                color: var(--theme-input-color);
            }

            @media screen and (max-width: 550px) {
                .avatar {
                    --avatar-size: 1rem;
                }
                .avatarLetters {
                    --avatar-font-size: 0.6rem;
                }
            }
        `;
    }
}
